/* globals window */
import { WithData, PT, React, connect } from '@gasbuddy/react';
import { Dimmer, Loader, Modal } from 'semantic-ui-react';
import { fetchApi } from '@gasbuddy/react/build/fetchApi';
import { ActionGroups } from '../../roles';
import { Action } from '../../reducers/actions';
import { Auth, Nav, AdminRoleList } from '../../components';

/**
 * Return the URL if running client side
 */
function clientUrl() {
  if (typeof window !== 'undefined') {
    return window.location.origin;
  }
  return '';
}

class BaseAdminPage extends React.Component {
  state = { };

  save = (accountId, add, remove) => {
    const { dispatch } = this.props;
    dispatch({
      type: `${Action.Api.Base}sync`,
      meta: { apiAction: true },
      payload: {
        url: '/identity/groups/sync',
        body: {
          account_id: accountId,
          add,
          remove,
        },
      },
    });
  };

  invite = () => {
    const { dispatch, match: { params: { email } } } = this.props;
    dispatch({
      type: `${Action.Api.Base}invite`,
      meta: { apiAction: true },
      payload: {
        which: 'invite',
        url: '/identity/signup/invite',
        body: { email },
      },
    });
  }

  clearInvite = () => {
    const { dispatch } = this.props;
    dispatch({ type: Action.Api.Clear, payload: 'invite' });
  }

  reset = async (accountId) => {
    await fetchApi({
      url: `/identity/user/${accountId}/password-reset`,
      body: { },
    });
    window.location.reload();
  }

  render() {
    const { api: { sync, invite }, match: { params: { email } } } = this.props;
    const { loading: syncLoading } = sync || {};
    const { loading: inviteLoading, body: inviteData = {} } = invite || {};
    return (
      <Auth
        forActions={ActionGroups.ViewAdminAccessPage}
      >
        <Nav>
          <div>
            <h1>{email}</h1>
            <Dimmer.Dimmable dimmed={syncLoading || inviteLoading}>
              <Dimmer active={syncLoading || inviteLoading}>
                <Loader />
              </Dimmer>
              <WithData url="/identity/groups" body={{ email, checkCredentials: true }}>
                <AdminRoleList onSave={this.save} onInvite={this.invite} onResetPassword={this.reset} email={email} />
              </WithData>
            </Dimmer.Dimmable>
            <Modal open={!!inviteData.unique_id} closeIcon onClose={this.clearInvite}>
              <Modal.Header>Invitation Created</Modal.Header>
              <Modal.Content>
                <Modal.Description>
                  <p>
                    Provide the link over one channel (like Slack) and the signup code over
                    another. The user should then create a password and store the OTP secret
                    on a separate app such as Duo or Google Authenticator. This token can
                    only be used once and must be used in the next 24 hours.
                  </p>
                  <p><a href={`/identity/signup/${inviteData.unique_id}`}>{`${clientUrl()}/identity/signup/${inviteData.unique_id}`}</a></p>
                  <p>
                    Signup Code:
                    {invite && invite.body && invite.body.random}
                  </p>
                </Modal.Description>
              </Modal.Content>
            </Modal>
          </div>
        </Nav>
      </Auth>
    );
  }
}

BaseAdminPage.propTypes = {
  match: PT.shape({ params: PT.shape({ email: PT.string }) }).isRequired,
  dispatch: PT.func.isRequired,
  api: PT.shape({
    sync: { loading: PT.bool },
    invite: { loading: PT.bool },
  }).isRequired,
};

export const AdminPage = connect(({ api }) => ({ api }))(BaseAdminPage);
